export default {
    "en": {
        "logsPage": {
            "logs": "Logs",
            "filterLogs": "Filter logs",
            "applyFilters": "Apply filters"
        },
        "passwords": {
            "password": "Passwords must be at least eight characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "unverified_email": "This email address has not been verified.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "completeRegistration": "Complete Registration",
            "language": "Language",
            "password": "Password",
            "confirmPassword": "Confirm Password",
            "complete": "Complete",
            "login": "Login",
            "emailAddress": "Email Address",
            "enterEmail": "Enter email",
            "rememberMe": "Remember Me",
            "forgotPasswordQuestion": "Forgot your password?",
            "resetPassword": "Reset Password",
            "newPassword": "New Password",
            "confirmNewPassword": "ConfirmNewPassword",
            "authorizingDevice": "Authorizing device",
            "requestNewPassword": "Request new password",
            "emailNotFound": "We have not found your email",
            "emailSent": "Email sent",
            "done": "Done",
            "send": "Send",
            "sending": "Sending",
            "updating": "Updating"
        },
        "languages": {
            "languageUpdated": "Language successfully updated",
            "en": "English",
            "hu": "Hungarian",
            "de": "German"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "sideMenu": {
            "myApps": "My apps",
            "myAccount": "My account",
            "logs": "Logs",
            "hotelSettings": "Hotel Settings",
            "contacts": "My Hotels",
            "subscriptions": "Subscriptions",
            "invoices": "Invoices",
            "hotelTags": "Hotel Tags",
            "userManagement": "User Management",
            "users": "Users",
            "inviteNewUser": "Invite new user",
            "managePermissions": "Manage permissions",
            "manageHotelGroups": "Manage hotel groups",
            "manageHotels": "Manage hotels",
            "manageApplications": "Manage applications",
            "manageInvoices": "Manage invoices",
            "tagManagement": "Tag management",
            "support": "Support",
            "documentation": "Documentation",
            "tickets": "Tickets",
            "contactSupport": "Contact support"
        },
        "contactsPage": {
            "manageContacts": "Manage Contacts",
            "billingContacts": "Billing Contacts",
            "generalContacts": "General Contacts",
            "hotelGroup": "General (Hotel Group)",
            "addNewContact": "Add new contact",
            "deleteContact": "Delete contact",
            "editContact": "Edit contact",
            "user": "User (optional)",
            "noUserSelected": "No user selected",
            "warningQuestion": "Are you sure you want to delete this contact",
            "noBillingContactAddedToHotelGroup": "No billing contacts added to this hotel group",
            "noBillingContactAddedToHotel": "No billing contacts added to this hotel",
            "noGeneralContactAddedToHotelGroup": "No general contacts added to this hotel group",
            "noGeneralContactAddedToHotel": "No general contacts added to this hotel",
            "contactUpdated": "Contact successfully updated",
            "contactDeleted": "Contact successfully deleted",
            "contactAdded": "New contact added"
        },
        "subscriptionsPage": {
            "manageSubscriptions": "Manage Subscriptions",
            "subscriptionStartedAt": "Subscription started at",
            "subscriptionExpirationDate": "Subscription expiration date",
            "contractExpirationDate": "Contract expiration date",
            "subscriptionPrice": "Subscription price",
            "billingFrequency": "Billing frequency",
            "billingFrequencyMessage": "{1} we send a bill in every month|[2,*] we send a bill in every {num} month",
            "contactPerson": "Contact person",
            "noAppAddedToHotelGroup": "No application added to this hotel group",
            "noSubscriptionMessage": "It seems you have no subscription at this hotel for this application",
            "inactiveContactPersonMessage": "This user is not active, please select a new contact person"
        },
        "usersPage": {
            "manageUsers": "Manage users",
            "updateUserData": "Update user data",
            "inviteNewUser": "Invite new user",
            "filterUsers": "Filter users",
            "resendVerificationEmail": "Resend verification email",
            "editUser": "Edit user",
            "deleteUser": "Delete user",
            "restoreUser": "Restore user",
            "warningQuestion": "Are you sure you want to delete this user?",
            "restoreWarningQuestion": "Are you sure you want to restore this user?",
            "showDeleted": "Show deleted users",
            "status": "Status",
            "statusActive": "Active",
            "statusDeleted": "Deleted",
            "userAdded": "User added",
            "notVerifiedYet": "not verified yet",
            "verificationEmailSent": "Verification email sent",
            "userUpdated": "User successfully updated",
            "userRestored": "User restored"
        },
        "inviteUserPage": {
            "inviteNewUser": "Invite new user",
            "invite": "Invite",
            "userAdded": "User added",
            "userWasDeleted": "A user with this email was previously deleted.",
            "restorePrompt": "Do you want to restore this user?",
            "restore": "Restore",
            "userRestored": "User restored"
        },
        "permissionsPage": {
            "manageUserPermissions": "Manage user permissions",
            "export": "Export",
            "listView": "List view",
            "gridView": "Grid view",
            "selectPermissions": "Select permissions",
            "setPermissionFor": "Set permission for {name}",
            "noAccess": "No Access",
            "upload": "Upload",
            "view": "View",
            "edit": "Edit",
            "admin": "Admin"
        },
        "invoicesPage": {
            "invoices": "Invoices",
            "downloadInvoice": "Download invoice",
            "noInvoice": "No invoice",
            "paid": "Paid",
            "unpaid": "Unpaid",
            "cancelled": "Cancelled"
        },
        "tagManagement": {
            "title": "Tag Management",
            "createNewTag": "Create New Tag",
            "editTag": "Edit Tag",
            "deleteTag": "Delete Tag",
            "loadingTags": "Loading tags...",
            "noTagsAvailable": "No tags available",
            "type": "Type",
            "admin": "Admin",
            "regular": "Regular",
            "tagName": "Tag Name",
            "tagNameRequired": "Tag name is required",
            "enterTagName": "Enter tag name...",
            "adminOnly": "Admin Only",
            "public": "Public",
            "adminOnlyDescription": "Admin-only tags can only be assigned by assist administrators",
            "rank": "Rank",
            "rankRequired": "Rank is required",
            "rankDescription": "Used for sorting tags (lower numbers appear first). Range: 1 to total number of tags.",
            "confirmDelete": "Confirm Delete",
            "deleteConfirmMessage": "Are you sure you want to delete the tag \"{tagName}\"?",
            "tagAssignedWarning": "This tag is assigned to {count} hotel(s).",
            "cannotDeleteAssigned": "You cannot delete it until it's removed from all hotels.",
            "failedToLoadTags": "Failed to load tags",
            "tagSuccessfullyUpdated": "Tag successfully updated",
            "tagSuccessfullyCreated": "Tag successfully created",
            "failedToSaveTag": "Failed to save tag",
            "tagSuccessfullyDeleted": "Tag successfully deleted",
            "failedToDeleteTag": "Failed to delete tag"
        },
        "myAccountPage": {
            "myAccount": "My Account",
            "personalData": "Personal Data",
            "editPassword": "Edit Password",
            "security": "Security",
            "twoFactorAuth": "Two-factor authentication",
            "currentDevice": "Current Device",
            "warningQuestion": "Are you sure you want to delete this device?",
            "checkEmailMessage": "Please check your inbox and confirm your new email",
            "userUpdated": "User data updated",
            "passwordChanged": "Password Changed",
            "deviceDeleted": "Device has deleted"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "general": {
            "id": "ID",
            "name": "Name",
            "email": "Email",
            "emailAddress": "Email address",
            "phone": "Phone",
            "actions": "Actions",
            "cancel": "Cancel",
            "close": "Close",
            "add": "Add",
            "warning": "Warning",
            "delete": "Delete",
            "loading": "Loading",
            "save": "Save",
            "saved": "Saved",
            "create": "Create",
            "update": "Update",
            "select": "Select",
            "all": "All",
            "logout": "Logout",
            "somethingWentWrong": "Something went wrong",
            "confirm": "Confirm",
            "success": "Success",
            "error": "Error",
            "language": "Language",
            "country": "Country",
            "city": "City",
            "operatingSystem": "Operating System",
            "browser": "Browser",
            "ipAddress": "IP Address",
            "lastLogin": "Last Login",
            "user": "User",
            "hotel": "Hotel",
            "app": "App",
            "application": "{1} Application|Applications",
            "context": "Context",
            "message": "Message",
            "level": "Level",
            "createdAt": "Created at",
            "expiryAt": "Expiry At",
            "status": "Status",
            "timeLeft": "Time left",
            "notActiveYet": "Not active yet",
            "active": "Active",
            "expired": "Expired",
            "invoiceNo": "Invoice No",
            "dateOfIssue": "Date of Issue",
            "dueDate": "Due date",
            "price": "Price",
            "role": "Role",
            "admin": "Admin",
            "subject": "Subject",
            "send": "Send",
            "sending": "Sending",
            "messageSent": "Message sent",
            "permission": "Permission",
            "saveChanges": "Save changes",
            "export": "Export"
        },
        "forms": {
            "editProfile": "Edit Profile",
            "personalData": "Personal Data",
            "name": "Name",
            "emailAddress": "Email Address",
            "language": "Language",
            "save": "Save",
            "editPassword": "Edit Password",
            "newPassword": "New Password",
            "confirmNewPassword": "Confirm New Password",
            "oldPassword": "Old Password",
            "changePassword": "Change Password",
            "password": "Password",
            "currentPassword": "Current Password",
            "send": "Send",
            "sending": "Sending"
        },
        "hotelTags": {
            "title": "Hotel Tags",
            "manageTags": "Manage Tags",
            "saveChanges": "Save Changes",
            "cancel": "Cancel",
            "remove": "Remove",
            "loadingHotels": "Loading hotels...",
            "loadingTags": "Loading tags...",
            "tagName": "Tag Name",
            "type": "Type",
            "actions": "Actions",
            "general": "General",
            "optional": "Optional",
            "admin": "Admin",
            "rank": "Rank",
            "manageHotelTags": "Manage Hotel Tags",
            "modalDescription": "Select tags for this hotel. Tags marked with",
            "modalDescriptionSuffix": "require admin permissions.",
            "noTagsAssigned": "No tags assigned to this hotel yet",
            "noTagsDescription": "Add tags to categorize and organize your hotel.",
            "noHotelsFound": "No hotels found",
            "noHotelsDescription": "Please contact support if you should have access to hotels.",
            "failedToLoadHotels": "Failed to load hotels",
            "failedToLoadData": "Failed to load data",
            "failedToLoadTags": "Failed to load tags",
            "tagsSuccessfullyUpdated": "Tags successfully updated",
            "failedToSaveChanges": "Failed to save changes",
            "tagSuccessfullyRemoved": "Tag successfully removed from hotel",
            "failedToRemoveTag": "Failed to remove tag"
        }
    },
    "hu": {
        "logsPage": {
            "logs": "Logok",
            "filterLogs": "Logok szűrése",
            "applyFilters": "Szűrés"
        },
        "passwords": {
            "password": "Passwords must be at least eight characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "auth": {
            "failed": "Hibás email cím vagy jelszó",
            "unverified_email": "A megadott email cím még nincs megerősítve",
            "throttle": "Túl sok próbálkozás. Próbálokzz újra {seconds} másodperc múlva.",
            "completeRegistration": "Regisztráció befejezése",
            "language": "Nyelv",
            "password": "Jelszó",
            "confirmPassword": "Jelszó mégegyszer",
            "complete": "Kész",
            "login": "Bejelentkezés",
            "emailAddress": "Email cím",
            "enterEmail": "Email cím",
            "rememberMe": "Emlékezz rám",
            "forgotPasswordQuestion": "Elfelejtetted a jelszavad?",
            "resetPassword": "Jelszó visszaállítás",
            "newPassword": "Új jelszó",
            "confirmNewPassword": "Új jelszó mégegyszer",
            "authorizingDevice": "Eszköz azonosítás folyamatban",
            "requestNewPassword": "Új jelszó igénylés",
            "emailNotFound": "A megadott email cím nem szerepel a rendszerünkben",
            "emailSent": "Email elküldve",
            "done": "Kész",
            "send": "Küldés",
            "sending": "Küldés",
            "updating": "Visszaállítás folyamatban"
        },
        "languages": {
            "languageUpdated": "Nyelv frissítve",
            "en": "Angol",
            "hu": "Magyar",
            "de": "Német"
        },
        "pagination": {
            "previous": "&laquo; Előző",
            "next": "Következő &raquo;"
        },
        "sideMenu": {
            "myApps": "Alkalmazásaim",
            "myAccount": "Fiókom",
            "logs": "Logok",
            "hotelSettings": "Szálloda beállításai",
            "contacts": "Kapcsolattartók",
            "subscriptions": "Előfizetések",
            "invoices": "Számlák",
            "hotelTags": "Szálloda címkék",
            "userManagement": "Felhasználó kezelés",
            "users": "Felhasználók",
            "inviteNewUser": "Új felhasználó meghívása",
            "managePermissions": "Jogosultságok kezelése",
            "manageHotelGroups": "Szálloda csoportok kezelése",
            "manageHotels": "Szállodák kezelése",
            "manageApplications": "Alkalmazások kezelése",
            "manageInvoices": "Számlák kezelése",
            "tagManagement": "Címkék kezelése",
            "support": "Support",
            "documentation": "Dokumentáció",
            "tickets": "Ticketek",
            "contactSupport": "Kapcsolat"
        },
        "contactsPage": {
            "manageContacts": "Kapcsolattartók",
            "billingContacts": "Számlázási kapcsolattartók",
            "generalContacts": "Általános kapcsolattartók",
            "hotelGroup": "Általános (Szálloda csoporthoz)",
            "addNewContact": "Új kapcsalattartó hozzáadása",
            "deleteContact": "Kapcsaolattartó törlése",
            "editContact": "Szerkesztés",
            "user": "Felhasználó (opcionális)",
            "noUserSelected": "Nincs felhasználó kiválasztva",
            "warningQuestion": "Biztosan törölni szeretnéd ezt a kapcsolattartót",
            "noBillingContactAddedToHotelGroup": "Nincs számlázási kapcsaolattartó hozzáadva ehhez a szálloda csoporthoz",
            "noBillingContactAddedToHotel": "Nincs számlázási kapcsaolattartó hozzáadva ehhez a szállodához",
            "noGeneralContactAddedToHotelGroup": "Nincs általános kapcsaolattartó hozzáadva ehhez a szálloda csoporthoz",
            "noGeneralContactAddedToHotel": "Nincs általános kapcsaolattartó hozzáadva ehhez a szállodához",
            "contactUpdated": "Kapcsolattartó frissítve",
            "contactDeleted": "Kapcsolattartó törölve",
            "contactAdded": "Új kapcsolattartó hozzáadva"
        },
        "subscriptionsPage": {
            "manageSubscriptions": "Előfizetések",
            "subscriptionStartedAt": "Előfizetés kezdete",
            "subscriptionExpirationDate": "Előfizetés vége",
            "contractExpirationDate": "Szerződés lejárati dátuma",
            "subscriptionPrice": "Előfizetés ára",
            "billingFrequency": "Számlázási gyakoriság",
            "billingFrequencyMessage": "{1} számlázás minden hónapban|[2,*] számlázás minden {num}. hónapban",
            "contactPerson": "Kapcsolattartó",
            "noAppAddedToHotelGroup": "Nincs egyetlen alkalmazás sem hozzárendelve ehhez a szálloda csoporthoz",
            "noSubscriptionMessage": "Úgy tűnik nincs előfizetésed ennél a szállodánál ehhez az alkalmazáshoz",
            "inactiveContactPersonMessage": "Ez a felhasználó már nem aktív. Kérlek válassz egy másik kapcsolattartót."
        },
        "usersPage": {
            "manageUsers": "Felhasználók kezelése",
            "updateUserData": "Felhasználó szerkesztése",
            "inviteNewUser": "Új felhasználó meghívása",
            "filterUsers": "Felhasználók szűrése",
            "resendVerificationEmail": "Visszaigazoló email újraküldése",
            "editUser": "Felhasználó szerkesztése",
            "deleteUser": "Felhasználó törlése",
            "restoreUser": "Felhasználó visszaállítása",
            "warningQuestion": "Biztosan törölni szeretnéd ezt a felhasználót?",
            "restoreWarningQuestion": "Biztosan vissza szeretnéd állítani ezt a felhasználót?",
            "showDeleted": "Törölt felhasználók megjelenítése",
            "status": "Státusz",
            "statusActive": "Aktív",
            "statusDeleted": "Törölt",
            "userAdded": "Felhasználó létrehozva",
            "notVerifiedYet": "nem visszaigazolt",
            "verificationEmailSent": "Visszaigazoló email elküldve",
            "userUpdated": "Felhasználó frissítve",
            "userRestored": "Felhasználó visszaállítva"
        },
        "inviteUserPage": {
            "inviteNewUser": "Új felhasználó hozzáadása",
            "invite": "Hozzáadás",
            "userAdded": "Felhasználó hozzáadva",
            "userWasDeleted": "Ez az email cím egy korábban törölt felhasználóhoz tartozik.",
            "restorePrompt": "Visszaállítod ezt a felhasználót?",
            "restore": "Visszaállítás",
            "userRestored": "Felhasználó visszaállítva"
        },
        "permissionsPage": {
            "manageUserPermissions": "Jogosultságok",
            "listView": "Lista nézet",
            "gridView": "Rács nézet",
            "selectPermissions": "Módosítás",
            "setPermissionFor": "{name} jogosultságainak szerkesztése",
            "noAccess": "Nincs hozzáférés",
            "upload": "Feltöltés",
            "view": "Megtekintés",
            "edit": "Szerkesztés",
            "admin": "Admin"
        },
        "invoicesPage": {
            "invoices": "Számlák",
            "downloadInvoice": "Számla letöltése",
            "noInvoice": "Nem érhető el számla",
            "paid": "Fizetett",
            "unpaid": "Fizetetlen",
            "cancelled": "Sztornó"
        },
        "tagManagement": {
            "title": "Címke Kezelés",
            "createNewTag": "Új Címke Létrehozása",
            "editTag": "Címke Szerkesztése",
            "deleteTag": "Címke Törlése",
            "loadingTags": "Címkék betöltése...",
            "noTagsAvailable": "Nincsenek elérhető címkék",
            "type": "Típus",
            "admin": "Admin",
            "regular": "Normál",
            "tagName": "Címke Neve",
            "tagNameRequired": "A címke neve kötelező",
            "enterTagName": "Írja be a címke nevét...",
            "adminOnly": "Csak Admin",
            "public": "Nyilvános",
            "adminOnlyDescription": "Az admin-only címkéket csak az assist adminisztrátorok rendelhetik hozzá",
            "rank": "Rangsor",
            "rankRequired": "A rangsor kötelező",
            "rankDescription": "Címkék rendezéséhez használatos (alacsonyabb számok előrébb jelennek meg). Tartomány: 1-től a címkék számáig.",
            "confirmDelete": "Törlés Megerősítése",
            "deleteConfirmMessage": "Biztosan törölni szeretné a \"{tagName}\" címkét?",
            "tagAssignedWarning": "Ez a címke {count} szállodához van hozzárendelve.",
            "cannotDeleteAssigned": "Nem törölheti, amíg el nem távolítja az összes szállodából.",
            "failedToLoadTags": "A címkék betöltése sikertelen",
            "tagSuccessfullyUpdated": "Címke sikeresen frissítve",
            "tagSuccessfullyCreated": "Címke sikeresen létrehozva",
            "failedToSaveTag": "A címke mentése sikertelen",
            "tagSuccessfullyDeleted": "Címke sikeresen törölve",
            "failedToDeleteTag": "A címke törlése sikertelen"
        },
        "myAccountPage": {
            "myAccount": "Fiókom",
            "personalData": "Személyes adatok",
            "editPassword": "Jelszó",
            "security": "Biztonság",
            "twoFactorAuth": "Két lépcsős azonosítás",
            "currentDevice": "Ez az eszköz",
            "warningQuestion": "Biztosan törölni szeretnéd ezt az eszközt?",
            "checkEmailMessage": "Erősítsd meg az email fiókodat az emailben kapott linken keresztül",
            "userUpdated": "Felhasználó adatai frissítve lettek",
            "passwordChanged": "A jelszó megváltozott",
            "deviceDeleted": "Eszköz törölve"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "general": {
            "id": "ID",
            "name": "Név",
            "email": "Email cím",
            "emailAddress": "Email cím",
            "phone": "Telefonszám",
            "actions": "Műveletek",
            "cancel": "Mégse",
            "close": "Bezárás",
            "add": "Hozzáadás",
            "warning": "Figyelmeztetés",
            "delete": "Törlés",
            "loading": "Töltés",
            "save": "Mentés",
            "saved": "Mentve",
            "create": "Létrehozás",
            "update": "Módosítás",
            "select": "Válassz",
            "all": "Összes",
            "logout": "Kijelentkezés",
            "somethingWentWrong": "Valami hiba történt",
            "confirm": "Jóváhagyás",
            "success": "Siker",
            "error": "Hiba",
            "language": "Nyelv",
            "country": "Ország",
            "city": "Város",
            "operatingSystem": "Operációs rendszer",
            "browser": "Böngésző",
            "ipAddress": "IP cím",
            "lastLogin": "Utolsó bejelentkezés",
            "user": "Felhasználó",
            "hotel": "Szálloda",
            "app": "App",
            "application": "{1} Alkalmazás|Alkalmazások",
            "context": "Kontextus",
            "message": "Üzenet",
            "level": "Szint",
            "createdAt": "Hozzáadva",
            "expiryAt": "Lejárat",
            "status": "Státusz",
            "timeLeft": "Hátralévő idő",
            "notActiveYet": "Még nem aktív",
            "active": "Actív",
            "expired": "Lejárt",
            "invoiceNo": "Számla sorszáma",
            "dateOfIssue": "Kiállítás dátuma",
            "dueDate": "Fizetési határidő",
            "price": "Végösszeg",
            "role": "Jogosultság",
            "admin": "Adminisztrátor",
            "subject": "Tárgy",
            "send": "Küldés",
            "sending": "Küldés",
            "messageSent": "Üzenet elküldve",
            "permission": "Jogosultság",
            "saveChanges": "Mentés",
            "export": "Export"
        },
        "forms": {
            "editProfile": "Beállítások",
            "personalData": "Személyes adatok",
            "name": "Név",
            "emailAddress": "Email cím",
            "language": "Nyelv",
            "save": "Mentés",
            "editPassword": "Jelszó módosítása",
            "newPassword": "Új jelszó",
            "confirmNewPassword": "Új jelszó mégegyszer",
            "oldPassword": "Régi jelszó",
            "changePassword": "Jelszó megváltoztatása",
            "password": "Jelszó",
            "currentPassword": "Jelenlegi jelszó",
            "send": "Send",
            "sending": "Sending"
        },
        "hotelTags": {
            "title": "Szálloda Címkék",
            "manageTags": "Címkék Kezelése",
            "saveChanges": "Változások Mentése",
            "cancel": "Mégse",
            "remove": "Eltávolítás",
            "loadingHotels": "Szállodák betöltése...",
            "loadingTags": "Címkék betöltése...",
            "tagName": "Címke Neve",
            "type": "Típus",
            "actions": "Műveletek",
            "general": "Általános",
            "optional": "Opcionális",
            "admin": "Admin",
            "rank": "Rangsor",
            "manageHotelTags": "Szálloda Címkék Kezelése",
            "modalDescription": "Válasszon címkéket ehhez a szállodához. A",
            "modalDescriptionSuffix": "jellel jelölt címkék admin jogosultságot igényelnek.",
            "noTagsAssigned": "Ehhez a szállodához még nincsenek címkék hozzárendelve",
            "noTagsDescription": "Adjon hozzá címkéket a szálloda kategorizálásához és rendszerezéséhez.",
            "noHotelsFound": "Nem találhatók szállodák",
            "noHotelsDescription": "Lépjen kapcsolatba a támogatással, ha szállodákhoz kellene hozzáférnie.",
            "failedToLoadHotels": "A szállodák betöltése sikertelen",
            "failedToLoadData": "Az adatok betöltése sikertelen",
            "failedToLoadTags": "A címkék betöltése sikertelen",
            "tagsSuccessfullyUpdated": "Címkék sikeresen frissítve",
            "failedToSaveChanges": "A változások mentése sikertelen",
            "tagSuccessfullyRemoved": "Címke sikeresen eltávolítva a szállodából",
            "failedToRemoveTag": "A címke eltávolítása sikertelen"
        }
    }
}
